import request from "@/utils/request";

export function getAllFreshSeedBag(params) {
    return request({
        url: "/api/services/app/FreshSeedBag/GetAll",
        method: "GET",
        params
    });
}

export function getFreshSeedBag(params) {
    return request({
        url: "/api/services/app/FreshSeedBag/Get",
        method: "GET",
        params
    });
}

export function getAllFreshSeedBagOptions() {
    return request({
        url: "/api/services/app/FreshSeedBag/GetAllForDropDown",
        method: "GET"
    });
}

export function createManyFreshSeedBagFromBunch(data) {
    return request({
        url: "/api/services/app/FreshSeedBag/CreateManyFromBunch",
        method: "POST",
        data
    });
}

export function createFreshSeedBag(data) {
    return request({
        url: "/api/services/app/FreshSeedBag/Create",
        method: "POST",
        data
    });
}

export function updateFreshSeedBag(data) {
    return request({
        url: "/api/services/app/FreshSeedBag/Update",
        method: "PUT",
        data
    });
}

export function deleteFreshSeedBag(params) {
    return request({
        url: "/api/services/app/FreshSeedBag/Delete",
        method: "DELETE",
        params
    });
}

export function deleteManyFreshSeedBag(data) {
    return request({
        url: "/api/services/app/FreshSeedBag/DeleteMany",
        method: "POST",
        data
    });
}

export function getFilterFields() {
    return request({
        url: "/api/services/app/FreshSeedBag/GetFilterInfo",
        method: "GET"    
    });
}




// WEBPACK FOOTER //
// ./src/api/fresh_seed_bag.js